import { BaseSelectors } from '@makemydeal/dr-activities-common';
import { IAdditionalSelectors } from '../types/IAdditionalSelectors';
import { ILeadform } from '../types/ILeadform';

export class Selectors extends BaseSelectors {
    static instance;

    constructor(public sliceName: string, public additionalSelectors: IAdditionalSelectors) {
        super(sliceName);

        Selectors.instance = this;
    }

    static getInstance = () => {
        return Selectors.instance;
    };

    /**
     * Get the slice of state for this activity
     * @param state Entire State Tree
     */
    getState = (state: any): ILeadform => {
        return super.getState(state) as ILeadform;
    };

    isLeadModalShown = (state: any): boolean => {
        return this.getState(state).isModalOpen;
    };

    getSuccessAction = (state: any): string => {
        return this.getState(state).successAction || '';
    };

    getTitle = (state: any): string => {
        return this.getState(state).title || '';
    };

    getDescription = (state: any): string => {
        return this.getState(state).description || '';
    };

    getSkipLink = (state: any): boolean => {
        return this.getState(state).skipLink || false;
    };

    getPreSubmitAction = (state: any): string => {
        return this.getState(state).preSubmitAction || '';
    };

    getExternalLeadSubmitFailureAction = (state: any): string | undefined => {
        return this.getState(state).externalLeadSubmitFailureAction || '';
    };

    getErrorDescription = (state: any): string => {
        return this.getState(state).errorDescription || '';
    };

    getExternalErrorCount = (state: any): number => {
        return this.getState(state).externalErrorCount || 0;
    };

    isLeadFormSubmitting = (state: any): boolean => {
        return this.getState(state).leadFormSubmitting || false;
    };

    isLeadFormSubmittedSuccess = (state: any): boolean => {
        return this.getState(state).leadFormSubmittedSuccess || false;
    };

    isLeadFormSubmittedFailure = (state: any): boolean => {
        return this.getState(state).leadFormSubmittedFailure || false;
    };

    isLeadFormReinitialized = (state: any): boolean => {
        return this.getState(state).leadFormReinitialized || false;
    };

    isLeadFormCCPAShown = (state: any): boolean => {
        return this.getState(state).ccpaShown || false;
    };

    getZipCodeLoading = (state): boolean => {
        return this.getState(state).zipCodeLoading || false;
    };
}
